module.exports = __webpack_public_path__ + "img/phpNginx.64ad9c33.png";